import * as lodash from 'lodash';
export const predefinedCurveNumbers = [
    0.2, 0.4, 0.6, 0.8, 1.0, 1.2, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0,
];
export function createPredefinedCurve(curveNo) {
    /*
     * Юрий Волков, [24.12.2021 17:01]
     * float k = (float)coef/10;
     *   float outside_temperature_celsius = ((float)outside_temperature/10) - 273;
     *   float x = -0.2*outside_temperature_celsius + 5;
     *   float a = -0.21*k - 0.06;
     *   float b = 6.04*k + 1.98;
     *   float c = -5.06*k + 18.06;
     *   float T_water = a*x*x + b*x + c;
     *
     * Юрий Волков, [24.12.2021 17:01]
     * У меня такие расчёты
     * Насколько я помню это с каких-то форумов про Калорматик 630
     */
    const temps = [20, 10, 0, -10, -20, -30, -40];
    const k = curveNo;
    const a = -0.21 * k - 0.06;
    const b = 6.04 * k + 1.98;
    const c = -5.06 * k + 18.06;
    return temps.map((temp) => {
        const x = -0.2 * temp + 5;
        const y = Math.min(100, a * x * x + b * x + c);
        return [temp, Math.round(y * 10) / 10];
    });
}
export function equalsToPredefinedCurve(xy, curveNo) {
    return lodash.isEqual(xy, createPredefinedCurve(curveNo));
}
